import React, { Fragment } from "react";
import { Loading } from "./Loading";
import { Button } from "react-bootstrap";
import axios from "axios";

import { connect } from "react-redux";
import { createUser, logOutUser, loadStatus } from "../actions/postAction";
import PropTypes from "prop-types";
import Swal from "sweetalert2";
import LoadingBar from "react-top-loading-bar";
import Moment from "react-moment";
import moment from "moment";
import "moment-timezone";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { BASE_URL } from "../constant";
import Loader from "react-loader-spinner";
import SimpleReactValidator from "simple-react-validator";
import { NetworkError } from "./NetworkError";
import {endpoints, http} from "../configs/https";

class Secretariat extends React.Component {
  constructor() {
    super();
    this.state = {
      executive_committee_meetings: "",
      freq: 0,
      office_bearer: 0,
      present: 0,
      submission: "",
      qaidat_sec: "",
      mulk_total: 0,
      mulk_present: 0,
      mulk_absent: 0,
      phone: "",
      isSubmitting: false,
      month: 0,
      modal: false,
      loading: true,
      networkError: false
    };
    this.toggle = this.toggle.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    document.title = "ETEEMAD - MKAN REPORT";
    this.setupValidator();
    //this.checkStatus();
  }

  setupValidator() {
    this.setState({
      loading: false
    });
    const { year, month } = this.props.monthYear;
    const {failed} = this.props.status;
    if (failed){
      this.props.loadStatus(month,year);
    }
    this.validator = new SimpleReactValidator();
  }


  toggle() {
    this.setState(prevState => ({
      modal: !prevState.modal
    }));
  }

  checkStatus() {
    const { month, year } = this.props.monthYear;

    axios
      .post(
        BASE_URL + `status/`,
        { month: month, year: year },
        {
          headers: { Authorization: `Bearer ${this.props.user.token}` }
        }
      )
      .then(res => {
        if (res.data.secretariat) {
          this.setState({
            submitted: res.data.secretariat,
            loading: false
          });
        }
        this.setState({
          loading: false
        });
      })
      .catch(error => {
        if (error.message === "Network Error") {
          const Toast = Swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000
          });

          Toast.fire({
            type: "warning",
            title:
              "Network error, try Reloading page. Possibly no internet connection "
          });
        } else {
          if (error.response.status === 401) {
            this.props.logOutUser();
            window.location.replace("/");
            this.setState({});
            const Toast = Swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000
            });

            Toast.fire({
              type: "error",
              title: "You need to log in again "
            });
          } else {
            const Toast = Swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000
            });

            Toast.fire({
              type: "error",
              title: "Something went wrong, try again."
            });
          }
        }
      });
  }

  handleChange(event) {
    const { name, value } = event.target;
    this.setState({
      [name]: value
    });
  }
  handleSubmit(event) {
    const { month, year, monthName } = this.props.monthYear;
    event.preventDefault();
    if (!this.validator.allValid()) {
      this.validator.showMessages();
      // rerender to show messages for the first time
      // you can use the autoForceUpdate option to do this automatically`
      this.forceUpdate();
      return;
    }

    if (this.state.phone.length > 11) {
      const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000
      });

      Toast.fire({
        type: "warning",
        title: "Nazim's phone number should not be greater than 11 characters"
      });
      return;
    }
    var a =
      parseInt(this.state.mulk_absent) + parseInt(this.state.mulk_present);

    if (a !== parseInt(this.state.mulk_total)) {
      const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000
      });

      Toast.fire({
        type: "warning",
        title:
          "Total number of mulk officers present and absent must equal total"
      });
      return;
    }

    Swal.fire({
      title:
        "Are you sure you want to submit your A'itmad report for " +
        monthName +
        " " +
        year +
        "?",
      text:
        "You won't be able to revert this after submitting, kindly check all details are accurate.",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Submit",
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33"
    }).then(result => {
      if (result.value) {
        this.setState({
          isSubmitting: true
        });

        this.LoadingBar.staticStart();

        http
          .post(
            endpoints.SECRETARIAT,
            {
              exec_meeting: this.state.executive_committee_meetings === "Yes",
              freq: this.state.freq,
              office_bearer: this.state.office_bearer,
              present: this.state.freq,
              submission: this.state.submission === "Yes",
              qaidat_sec: this.state.qaidat_sec === "Yes",
              mulk_total: this.state.mulk_total,
              mulk_present: this.state.mulk_present,
              mulk_absent: this.state.mulk_absent,
              phone: this.state.phone,
              month: month,
              year: year
            },
          )
          .then(res => {
            if (res.status != 201) {
              const Toast = Swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000
              });

              Toast.fire({
                type: "warning",
                title: "There is an error in your submission, try again"
              });
              this.setState({
                isSubmitting: false
              });
              this.LoadingBar.complete();
            } else {
              const Toast = Swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000
              });

              Toast.fire({
                type: "success",
                title: "Etemaad report submitted successfully "
              });

              this.LoadingBar.complete();
              this.setState({
                phone: "",
                executive_committee_meetings: false,
                freq: 0,
                office_bearer: 0,
                present: 0,
                submission: false,
                qaidat_sec: false,
                mulk_total: 0,
                mulk_present: 0,
                mulk_absent: 0,
                isSubmitting: false,
                returned_phone: res.data.phone,
                modal: true
              });
              this.props.loadStatus(month,year);
            }
          })
            .catch(error => {
              this.setState({
                isSubmitting: false
              });
              this.LoadingBar.complete();
              let errorMessage =
                  (typeof error === "string" && error) ||
                  "An error occured, please try again in a moment.";

              const Toast = Swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000
              });

              Toast.fire({
                type: "error",
                title: errorMessage
              });
            });
      }
    });
  }
  render() {
    const { year, monthName } = this.props.monthYear;
    const {data, isFetching, failed} = this.props.status;
    const {isSubmitting} = this.state;

    return (
      <div>
        {this.state.networkError || failed ? (
          <NetworkError />
        ) : (
          <section className="content">
            {this.state.loading || isFetching ? (
              <div>
                <div className="spinner">
                  <Loader
                    type="ThreeDots"
                    color="#00BFFF"
                    height="40"
                    width="40"
                  />
                </div>
              </div>
            ) : (
              <div>
                {!data.secretariat ? (
                  <div>
                    <LoadingBar onRef={ref => (this.LoadingBar = ref)} />

                    <div className="row">
                      <div className="col-md-12">
                        <div className="card">
                          <div className="card-header card-header-primary">
                            <h4 className="card-title">
                              A'itmad (SECRETARIAT) - {monthName},{" "}
                              {year}
                            </h4>
                            <p className="card-category">
                              Complete the form below
                            </p>
                          </div>
                          <div className="card-body">
                            <form onSubmit={this.handleSubmit}>
                              <div className="row">
                                <div className="col-md-6">
                                  <div className="form-group">
                                    <label className="bmd-label-floating">
                                      Were the Executive Committee Meetings
                                      conducted during the month?{" "}
                                    </label>

                                    <div className="form-check">
                                      <label className="form-check-label">
                                        <input
                                          className="form-check-input"
                                          type="radio"
                                          id="executive_committee_meetings"
                                          onChange={this.handleChange}
                                          name="executive_committee_meetings"
                                          value="Yes"
                                        />{" "}
                                        Yes
                                        <span className="form-check-sign">
                                          <span className="check" />
                                        </span>
                                      </label>

                                      <label className="form-check-label">
                                        <input
                                          className="form-check-input"
                                          type="radio"
                                          onChange={this.handleChange}
                                          name="executive_committee_meetings"
                                          value="No"
                                        />{" "}
                                        No
                                        <span className="form-check-sign">
                                          <span className="check" />
                                        </span>
                                      </label>
                                    </div>
                                  </div>
                                  <span className="text-danger">
                                    {this.validator.message(
                                      "meetings",
                                      this.state.executive_committee_meetings,
                                      "required"
                                    )}
                                  </span>
                                </div>
                                <div className="col-md-6">
                                  <div className="form-group">
                                    <label className="bmd-label-floating">
                                      How many?{" "}
                                    </label>
                                    <input
                                      type="number"
                                      className="form-control"
                                      id="freq"
                                      name="freq"
                                      min="0"
                                      autoComplete="off"
                                      value={this.state.freq}
                                      onChange={this.handleChange}
                                      required
                                    />
                                  </div>
                                </div>
                              </div>

                              <div className="row">
                                <div className="col-md-6">
                                  <div className="form-group">
                                    <label className="bmd-label-floating">
                                      Total Number of Office–bearer Present
                                    </label>
                                    <input
                                      type="number"
                                      min="0"
                                      className="form-control"
                                      id="office_bearer"
                                      name="office_bearer"
                                      value={this.state.office_bearer}
                                      onChange={this.handleChange}
                                      required
                                    />
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="form-group">
                                    <label className="bmd-label-floating">
                                      Whether previous report for last month was
                                      submitted
                                    </label>
                                    <div className="form-check">
                                      <label className="form-check-label">
                                        <input
                                          className="form-check-input"
                                          type="radio"
                                          id=""
                                          onChange={this.handleChange}
                                          name="submission"
                                          value="Yes"
                                        />{" "}
                                        Yes
                                        <span className="form-check-sign">
                                          <span className="check" />
                                        </span>
                                      </label>

                                      <label className="form-check-label">
                                        <input
                                          className="form-check-input"
                                          type="radio"
                                          onChange={this.handleChange}
                                          name="submission"
                                          value="No"
                                        />{" "}
                                        No
                                        <span className="form-check-sign">
                                          <span className="check" />
                                        </span>
                                      </label>
                                    </div>
                                  </div>
                                  <span className="text-danger">
                                    {this.validator.message(
                                      "report status",
                                      this.state.submission,
                                      "required"
                                    )}
                                  </span>
                                </div>
                              </div>

                              <div className="row">
                                <div className="col-md-6">
                                  <div className="form-group">
                                    <label className="bmd-label-floating">
                                      Do you have Qaida'at Secretary?
                                    </label>
                                    <div className="form-check">
                                      <label className="form-check-label">
                                        <input
                                          className="form-check-input"
                                          type="radio"
                                          id=""
                                          onChange={this.handleChange}
                                          name="qaidat_sec"
                                          value="Yes"
                                        />{" "}
                                        Yes
                                        <span className="form-check-sign">
                                          <span className="check" />
                                        </span>
                                      </label>

                                      <label className="form-check-label">
                                        <input
                                          className="form-check-input"
                                          type="radio"
                                          onChange={this.handleChange}
                                          name="qaidat_sec"
                                          value="No"
                                        />{" "}
                                        No
                                        <span className="form-check-sign">
                                          <span className="check" />
                                        </span>
                                      </label>
                                    </div>
                                  </div>
                                  <span className="text-danger">
                                    {this.validator.message(
                                      "qaidat secretary",
                                      this.state.qaidat_sec,
                                      "required"
                                    )}
                                  </span>
                                </div>
                                <div className="col-md-6">
                                  <div className="form-group">
                                    <label className="bmd-label-floating">
                                      Number of Mulk Members in the Qaidat
                                    </label>
                                    <input
                                      type="number"
                                      className="form-control"
                                      id="mulk_total"
                                      name="mulk_total"
                                      min="0"
                                      value={this.state.mulk_total}
                                      onChange={this.handleChange}
                                      required
                                    />
                                  </div>
                                </div>
                              </div>

                              <div className="row">
                                <div className="col-md-6">
                                  <div className="form-group">
                                    <label className="bmd-label-floating">
                                      No Present at meeting
                                    </label>
                                    <input
                                      type="number"
                                      className="form-control"
                                      id="mulk_present"
                                      name="mulk_present"
                                      min="0"
                                      value={this.state.mulk_present}
                                      onChange={this.handleChange}
                                      required
                                    />
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="form-group">
                                    <label className="bmd-label-floating">
                                      No Absent
                                    </label>
                                    <input
                                      type="number"
                                      className="form-control"
                                      id="mulk_absent"
                                      name="mulk_absent"
                                      min="0"
                                      value={this.state.mulk_absent}
                                      onChange={this.handleChange}
                                      required
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-md-6">
                                  <div className="form-group">
                                    <label className="bmd-label-floating">
                                      Motamad's Phone
                                    </label>
                                    <input
                                      type="number"
                                      className="form-control"
                                      id="phone"
                                      name="phone"
                                      value={this.state.phone}
                                      onChange={this.handleChange}
                                    />
                                  </div>
                                  <span className="text-danger">
                                    {this.validator.message(
                                      "motamad's phone number",
                                      this.state.phone,
                                      "required|min:5|max:11"
                                    )}
                                  </span>
                                </div>
                              </div>

                              {isSubmitting ? <Loading /> : ""}

                              <button
                                type="submit"
                                className="btn btn-success pull-right"
                                disabled={isSubmitting}
                              >
                                {isSubmitting ? "Loading..." : "Submit"}
                              </button>
                              <div className="clearfix" />
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div>
                      {/* <Button color="danger" onClick={this.toggle}>{this.props.buttonLabel}</Button> */}
                      <Modal
                        isOpen={this.state.modal}
                        toggle={this.toggle}
                        className={this.props.className}
                      >
                        <ModalHeader toggle={this.toggle}>
                          Report submission status
                        </ModalHeader>
                        <ModalBody>
                          <p>
                            Submitted By : {this.state.submitted_by}
                            <br />
                            Date of Submission :{" "}
                            <Moment date={this.state.dateof} />
                            <br />
                            Tarbiyyah Programs conducted:{" "}
                            {this.state.returned_program}
                            {/* <br/> */}
                            {/* Attendance : {this.state.returned_attendance}
<br/>
Khuddam who observe Congregrational prayers in Mosque : {this.state.returned_cong}
<br/>
Khuddam who write letter to huzur : {this.state.returned_letter}
<br/>
Khuddam who watch MTA reagularly : {this.state.returned_mta}
<br/>
Khuddam who are regular in Tahajjud prayers : {this.state.returned_tahajud}
<br/>
Khuddam who are regular in 5 daily prayers : {this.state.returned_daily}
<br/>
Khuddam who engaged in voluntary fast : {this.state.returned_fast}
<br/>
Khuddam who read Condition of Baiat : {this.state.returned_biat} */}
                            <br />
                            Nazim Tarbiyya's Phone : {this.state.returned_phone}
                          </p>
                        </ModalBody>
                        <ModalFooter>
                          <Button color="primary" onClick={this.toggle}>
                            Close
                          </Button>
                        </ModalFooter>
                      </Modal>
                    </div>
                  </div>
                ) : (
                  <div className="d-flex align-items-center">
                    <h2>
                      You already submitted A'itmad report for{" "}
                      <b>
                        {monthName}, {year}
                      </b>
                    </h2>
                  </div>
                )}
              </div>
            )}
          </section>
        )}
      </div>
    );
  }
}

Secretariat.propTypes = {
  createUser: PropTypes.func.isRequired,
  logOutUser: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  isLoggedIn: PropTypes.bool.isRequired
};
const mapStateToProps = state => ({
  user: state.person.user,
  isLoggedIn: state.person.isLoggedIn,
  monthYear: state.currentMonth.monthYear,
  status: state.status,
});

export default connect(mapStateToProps, { createUser, logOutUser,loadStatus })(
  Secretariat
);
